export enum ContractualTime {
    LESS_1_YEAR = '1A',
    BETWEEN_1_5_YEARS = '2A',
    BETWEEN_5_10_YEARS = '3A',
    MORE_10_YEARS = '4A',
}
